// @flow

import { onlyNumbers } from '@tectonics/prs/normalize';
import { type ArgentineDocumentType } from './types';

export function normalizeDocument(documentType: ArgentineDocumentType, document: ?string): string {
  const normalized = document ? onlyNumbers(document) : '';
  return documentType === 'DNI'
    ? normalized.substr(0, 8)
    : normalized;
}
